(function () {
    'use strict';

    angular
        .module('directives.GOVHistoryCtxt', ['services.historyCtxt'])
        .directive('govHistoryCtxt', directive);

    directive.$inject = ['historyCtxtService'];

    function directive(historyCtxtService) {
        return {
            restrict: 'AE',
            scope: {
                defaultStateContext: '='
            },
            template: '<div ng-include="getTemplateUrl()"></div>',

            controller: ['$scope', function ($scope) {

                // Go To Context
                $scope.goToContext = historyCtxtService.goToContext;

                // Get Template Url
                $scope.getTemplateUrl = historyCtxtService.getCtxtTemplateUrl;

                // Init
                $scope.init = function () {
                    if (historyCtxtService.hasContext()) return;
                    if (_.isUndefined($scope.defaultStateContext)) return;

                    historyCtxtService.setContextAsDefault();
                    historyCtxtService.setCtxName($scope.defaultStateContext.ctxName);
                    historyCtxtService.setCtxItem($scope.defaultStateContext.ctxItem);
                };
            }],
            link: function (scope, element, attrs) {
                scope.init();

                scope.ctxItem = historyCtxtService.getCtxItem();
            }
        };
    }
})();